<template>
    <div class="base-div">
            <a
                type="button"
                @click="openHistory"
                title="Get change history"
            >
                <i aria-hidden="true" class="far fa-eye"></i>
            </a>

        <alteration-modal
            v-if="isModalVisible"
            @close="closeHistory"
            :title="`${name} - Change History`"
        >
        <template v-slot:body>
            <div v-if="isLoading"> Loading... </div>
            <div v-if="!isLoading && history && !error">
                <div >
                    <table>
                        <thead>
                            <tr>
                                <th>Who</th>
                                <th>When</th>
                                <th>From</th>
                                <th>To</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(alteration, index) in history" :key="index">
                                <td>{{ alteration.name }} {{alteration.last_name}}</td>
                                <td>{{ alteration.created_at }}</td>
                                <td v-html="formatText(alteration.old_value)"></td>
                                <td v-html="formatText(alteration.new_value)"></td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div v-if="!isLoading && !history && !error"> Nothing found</div>
            <div v-if="!isLoading && !history && error">
                <p v-for="(field, index) in error" :key="index">
                    <b>{{ index }}:</b> - {{ field[0] }}
                </p>
            </div>

        </template>
        </alteration-modal>
    </div>
</template>

<script>
export default {
    props: {
        name:       { type: String, required: true }, //For modal header
        attribute:  { type: String, required: true }, //Attribute we're searching
        subject_id: { type: Number, required: true }, //ID
        log_name:   { type: String, required: true }
    },
    data() {
        return {
            isModalVisible: false,
            history: null,
            isLoading: true,
            error: null
        };
    },
    methods: {
        formatText: function(text) {
            if(typeof(text) === 'string' && text == 'null') {
                return '';
            }

            if(text) {
                text = text.replace(/(\\r)*\\n/g, '<br/>').replace(/^"(.*)"$/, '$1');
            }

            return text;
        },

        //Sets visibility and fetch data
        openHistory: function() {
            this.isModalVisible = true;
                console.log(this);
            axios.post("/history/getHistory", {
                log_name: this.log_name,
                attribute: this.attribute,
                subject_id: this.subject_id
            }).then(res => {
                this.isLoading = false;
                console.table = res.data[0];
                this.history = res.data[0];
            }).catch(err => {
                this.isLoading = false;
                this.error = err.response.data;
            });
        },

        //Resets all to default closed
        closeHistory: function() {
            this.isModalVisible = false;
            this.history = null;
            this.isLoading = true;
        }
    }
};
</script>

<style scoped>
.base-div {
    float: right;
}

a {
    cursor: pointer;
}

tbody tr:nth-child(odd) {
    background: rgba(0,0,0,0.3);
}
table {
    min-width: 100%;
}
tbody td,
thead th {
  padding-left: 20px;
}
tbody td:first-child,
thead th:first-child {
  padding-left: 5px;
}
tbody td:last-child,
thead th:last-child {
    padding-right: 5px;
}
</style>
